import { render } from "./icon-arrow-right.vue?vue&type=template&id=1093026e"
import script from "./icon-arrow-right.vue?vue&type=script&lang=js"
export * from "./icon-arrow-right.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__